import { render, staticRenderFns } from "./auto.vue?vue&type=template&id=7e06ec6a&scoped=true"
import script from "./auto.vue?vue&type=script&lang=ts"
export * from "./auto.vue?vue&type=script&lang=ts"
import style0 from "./auto.vue?vue&type=style&index=0&id=7e06ec6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e06ec6a",
  null
  
)

export default component.exports